import React from 'react';
import Header from './header';

import { DEBUG, decrypt, URL } from '../variables';
import { connect } from 'react-redux';
import { mudarFaculdade, mudarUser, changeState, mudarStream, mudarDevices, mudarCamModal, logout, mudarProcesso } from '../actions/AppActions';
import ChangeCamModal from './changeCamModal';
import { Redirect } from 'react-router-dom';
import SelectProccess from './SelectProccess';
import { ProgressBar } from 'react-bootstrap';
import { CircularProgress } from '@material-ui/core';
import { Link } from 'react-router-dom';
import Chat from './Chat';
import {
    CameraPlus, FileText, Gear, Microphone, MonitorArrowUp, ShieldCheck, VideoCamera
} from '@phosphor-icons/react';
import { CandidateLoader, CandidateValidationNotice } from './CandidateUi';
import { QRCodeCanvas } from 'qrcode.react';
import { getLanguageTexts, getSelectedLanguage } from '../language';



let silence = () => {
    let ctx = new AudioContext(), oscillator = ctx.createOscillator();
    let dst = oscillator.connect(ctx.createMediaStreamDestination());
    oscillator.start();
    return Object.assign(dst.stream.getAudioTracks()[0], { enabled: false });
}



//   testSupport([
//     {client: 'Chrome'},
//   ]);

//   function testSupport(supportedDevices) {
//     const deviceDetector = new DeviceDetector();
//     const detectedDevice = deviceDetector.parse(navigator.userAgent);

//     let isSupported = false;
//     for (const device of supportedDevices) {
//       if (device.client !== undefined) {
//         const re = new RegExp(`^${device.client}$`);
//         if (!re.test(detectedDevice.client.name)) {
//           continue;
//         }
//       }
//       if (device.os !== undefined) {
//         const re = new RegExp(`^${device.os}$`);
//         if (!re.test(detectedDevice.os.name)) {
//           continue;
//         }
//       }
//       isSupported = true;
//       break;
//     }
//     if (!isSupported) {
//       alert(`This demo, running on ${detectedDevice.client.name}/${detectedDevice.os.name}, ` +
//             `is not well supported at this time, continue at your own risk.`);
//     }
//   }

// We'll add this to our control panel later, but we'll save it here so we can
// call tick() each time the graph runs.

// Optimization: Turn off animated spinner after its hiding animation is done.


class Termos extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            msg: '',
            loading_camera: false,
            show_video: false,
            show_screen_sharing: false,
            show_screen: false,
            show_solicitar: true,
            show_aceitar: false,
            redirect: false,
            path: '/processo',
            show_screen: false,
            show_config: false,
            value_progress:0,
            chat_show: false,
        }
        this.props.stream_ref.current = null;
        this.stream_screen = null;

        this.videoRef = React.createRef();
        this.screenRef = React.createRef();

        this.unmont_ = false;

        // this.props.video()=null;
    }
    componentDidMount() {
        this.props.changeState({ candidate_stage: 'terms' });
        console.log(this.props)
        this.props.changeStateParent({audio_detected:false, show_face_mesh: false,left_movement:false,face_detected:false,right_movement:false,center_movement:false });
        this.props.stream_ref.current=null;

        // setTimeout(()=>{
        //      if(this.stream_screen!=null){
        //     this.stream_screen.getTracks().map((track)=>track.stop())
        // }
        // if(this.stream!=null){
        //     this.stream.getTracks().map((track)=>track.stop())
        // }
        // console.log('stopp')
        // },10000);
        if (this.props.location.search.includes('error')) {
            this.setState({ msg: this.props.location.search.split('=')[1] });
            this.props.history.replace('/');
        }
        this.updateChatVisibility();
        // this.props.mudarStream(null);
        if (this.props.stream_screen != null) {
            try {
                this.props.stream_screen.getVideoTracks()[0].onended = function () { }

                this.props.stream_screen.getTracks().map((track) => track.stop())
            } catch (e) {

            }
        }
        if (this.props.stream != null) {
            try {
                this.props.stream.oninactive = function () { }
                this.props.stream.getTracks().map((track) => track.stop())
            } catch (e) {

            }
        }

        this.props.changeState({ stream_screen: null, stream: null });
        if (this.props.processo.simulado == false) {
            this.logs_timeout = setTimeout(() => {
                this.salvar_log();
            }, this.props.processo.save_timer_pre_exam);
        }

    }

    componentDidUpdate(prevProps) {
        if (prevProps.processo == null || this.props.processo == null || prevProps.processo.id != this.props.processo.id || prevProps.processo.inicio != this.props.processo.inicio || prevProps.processo.chat_time != this.props.processo.chat_time) {
            this.updateChatVisibility();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.logs_timeout);
        clearTimeout(this.chat_timeout);
        // this.stream = null;
        this.stream_screen = null;

        if (this.videoRef.current != null) {
            this.videoRef.current.srcObject = null;
        }
        if (this.screenRef.current != null) {
            this.screenRef.current.srcObject = null;
        }
        this.unmont_ = true;

    }

    salvar_log() {
        fetch(`${URL}api/salvar_log?v=a&screen=termo&processo_id=${this.props.processo.id}&processo_name=${this.props.processo.name}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {
                    if (resp.processo != null && resp.processo.updated_at != this.props.processo.updated_at) {
                        this.props.mudarProcesso(resp.processo);
                    }
                    if (this.unmont_ == false) {

                        this.logs_timeout = setTimeout(() => {
                            this.salvar_log();
                        }, this.props.processo.save_timer_pre_exam);
                    }
                }
            } catch (err) {
                console.log(err);
                if (this.unmont_ == false) {

                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, this.props.processo.save_timer_pre_exam);
                }
            }

        })
            .catch((err) => {
                console.log(err);
                if (this.unmont_ == false) {

                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, this.props.processo.save_timer_pre_exam);
                }
            });
    }

    updateChatVisibility() {
        clearTimeout(this.chat_timeout);

        if (this.state.chat_show == true || this.props.processo == null) {
            return;
        }

        const chatTime = parseInt(this.props.processo.chat_time || 0, 10);
        const inicio = new Date(this.props.processo.inicio).getTime();

        if (Number.isNaN(inicio)) {
            this.setState({ chat_show: true });
            return;
        }

        const secondsUntilStart = Math.ceil((inicio - Date.now()) / 1000);
        if (secondsUntilStart <= chatTime) {
            this.setState({ chat_show: true });
            return;
        }

        const secondsUntilChat = Math.max(1, secondsUntilStart - chatTime);
        this.chat_timeout = setTimeout(() => {
            this.updateChatVisibility();
        }, Math.min(secondsUntilChat, 60) * 1000);
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0;
            const v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    send_message(texto) {
        if (texto == null || texto.trim() == '' || texto.length >= 1000 || this.props.socket == null) {
            return false;
        }

        const uid_msg = this.uuidv4();
        this.props.socket.emit('send_msg_fiscal', {
            processo_id: this.props.processo.id,
            msg: texto,
            sala_id: this.props.sala.id,
            aluno_id: this.props.user.id,
            nome_chat: this.props.user.name,
            id_msg: uid_msg,
            faculdade_id: this.props.faculdade.id
        });

        this.props.changeState({
            mensagens: [...this.props.mensagens, {
                type_message: 'message',
                sender: { id: this.props.user.id, name: this.props.user.name },
                sender_id: this.props.user.id,
                receive_id: null,
                sala_id: this.props.sala.id,
                uuid: uid_msg,
                visto: undefined,
                message: texto
            }]
        });
        return true;
    }



    salvar_log_permission(msg) {
        fetch(`${URL}api/salvar_log?v=a&screen=termo_permission&processo_id=${this.props.processo.id}&processo_name=${this.props.processo.name}&msg=${msg}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {

                }
            } catch (err) {
                console.log(err);

            }

        })
            .catch((err) => {
                console.log(err);

            });
    }



    solicitar_camera() {
        this.setState({ loading_camera: true, msg: '', show_solicitar: false });
        navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then((stream) => this.get_camera(stream)).catch(this.handleError.bind(this));
    }

    async get_camera(stream_) {
        stream_.getTracks().map((track) => track.stop())
        var devices = await navigator.mediaDevices.enumerateDevices();
        let device_local = localStorage.getItem("deviceId")
        let device_local_mic = localStorage.getItem("deviceIdMic")

        console.log(devices);
        let exists = false;
        let exists_mic=false;
        let devices_camera = [];
        let devices_mic = [];
        var _stream = null;
        let devices_cam_id = []
        let devices_mic_id = []

        for (let i = 0; i < devices.length; i++) {
            if (devices[i].kind == 'videoinput') {
                if (!devices_cam_id.includes(devices[i].deviceId)) {
                    devices_camera.push(devices[i]);
                    devices_cam_id.push(devices[i].deviceId);

                }
                if (device_local == devices[i].deviceId) {
                    exists = true;
                }
            }
            else if (devices[i].kind == 'audioinput') {
                if (!devices_mic_id.includes(devices[i].deviceId)) {
                    devices_mic.push(devices[i]);
                    devices_mic_id.push(devices[i].deviceId);

                }
                if (device_local_mic == devices[i].deviceId) {
                    exists_mic = true;
                }
            }

        }
        console.log(devices_camera);
        console.log('oi');
        if (devices_camera.length > 0 && devices_mic.length > 0) {
            let use = '';
            let use_mic=''
            if (exists == true) {
                use = device_local;
            }
            else {
                localStorage.setItem("deviceId", devices_camera[0]?.deviceId);
                use = devices_camera[0]?.deviceId;
            }
            if (exists_mic == true) {
                use_mic = device_local_mic;
            }
            else {
                localStorage.setItem("deviceIdMic", devices_mic[0]?.deviceId);
                use_mic = devices_mic[0]?.deviceId;
            }
            console.log(use)
            console.log(exists_mic,use_mic,devices_mic)

            this.props.mudarDevices({ devices_camera: devices_camera, devices_mic, device_select: use,device_select_mic:use_mic })
            navigator.mediaDevices.getUserMedia({
                video: {
                    deviceId: {exact:use},
                    frameRate: 4,
                    facingMode: "user",
                    width: 320,
                    height: 240
                }, audio: {deviceId:{exact:use_mic}}
            }).
                then(this.handleSuccess.bind(this)).catch(this.handleError.bind(this));
        }
        else {
            const t = getLanguageTexts(getSelectedLanguage());
            this.setState({ show_solicitar: true, loading_camera: false, msg: t.media_not_found })
        }
    }

    handleSuccess(stream) {
        console.log(stream.getTracks())
        this.setState({show_screen:false})
        this.props.changeStateParent({audio_detected:false,left_movement:false,face_detected:false,right_movement:false,center_movement:false});    

        // screenshotButton.disabled = false;
        // window.location="/processos_user"
        if (this.props.stream_ref.current) {
            this.props.stream_ref.current.oninactive = () => { }
            this.props.stream_ref.current.getTracks().map((track) => track.stop())
            if (this.stream_screen) {
                this.stream_screen.getVideoTracks()[0].onended = () => {}
                this.stream_screen.getTracks().map((track) => track.stop())
                this.props.changeState({ stream_screen: null })
                this.stream_screen = null;

            }
        }
        this.props.stream_ref.current = stream;
        this.props.stream_ref.current.oninactive = () => {
            this.props.stream_ref.current = null;

            this.props.changeState({ stream: null });
            if (this.stream_screen) {
                
                this.stream_screen.getVideoTracks()[0].onended = () => {}
                this.stream_screen.getTracks().map((track) => track.stop())
                this.stream_screen = null;
                this.props.changeState({ stream_screen: null })

            }
            const t = getLanguageTexts(getSelectedLanguage());
            this.setState({  show_screen: false, show_aceitar: false, show_solicitar: true, show_screen_sharing: false, show_video: false, loading_camera: false, stream: null, msg: t.camera_permission_denied });
            this.props.changeStateParent({audio_detected:false,left_movement:false,right_movement:false,center_movement:false,face_detected:false,show_face_mesh:false})
            this.salvar_log_permission('Cancelou permissão de câmera');

        }
        if (this.props.processo.screen_sharing == true && this.props.processo.type_fiscalization == 'all') {

            this.setState({ show_screen_sharing: true, loading_camera: false, show_video: true }, () => {
                this.props.video().current.style.display = 'flex';
                this.props.video().current.volume = 0;

                this.videoRef.current.style.display = 'flex';
                this.videoRef.current.volume = 0;
                if(!this.props.processo.face_validation){

                    // this.props.video().current.srcObject = stream;
                    this.videoRef.current.srcObject = stream;

                }
                else{
                    console.log('aquiii')
                    this.videoRef.current.srcObject = stream;
                    // this.props.changeStateParent({loading_media:true,show_face_mesh:true});
                }
               
            });
        }
        else {

            this.setState({ show_aceitar: true, loading_camera: false, show_video: true }, () => {
                this.props.video().current.style.display = 'flex';
                this.props.video().current.volume = 0;

                this.videoRef.current.style.display = 'flex';
                this.videoRef.current.volume = 0;
                if(!this.props.processo.face_validation){
                    // this.props.video().current.srcObject = stream;
                    this.videoRef.current.srcObject = stream;

                }
                else{
                    this.videoRef.current.srcObject = stream;
                    // this.props.changeStateParent({loading_media:true,show_face_mesh:true});
                }
            });
        }
        this.salvar_log_permission('Aceitou permissão de câmera');


    }

    aceitar_termos() {
        // this.setState({ loading_camera: true, msg: '' });
        // this.props.mudarStream(this.stream);
        this.props.changeState({ stream_screen: this.stream_screen, stream: this.props.stream_ref.current });

        this.setState({ redirect: true });
    }

    screenSharing() {
        let extended = DEBUG ? false : window?.screen?.isExtended;
        const t = getLanguageTexts(getSelectedLanguage());

        if (extended == true) {
            this.setState({ loading_camera: false, msg: t.only_one_monitor_screen_share, show_screen_sharing: true });
            return;
        }
        this.setState({ loading_camera: true, show_screen_sharing: false, msg: '' });
        navigator.mediaDevices
            .getDisplayMedia({
                audio: false, video: {
                    frameRate: 24,
                    displaySurface: "monitor",
                    height: 500
                }
            }
            )
            .then((strm) => {
                let displaySurface = strm.getVideoTracks()[0].getSettings().displaySurface;
                if (displaySurface !== 'monitor') {
                    strm.getTracks().map((track) => track.stop());
                    this.setState({ loading_camera: false, msg: t.full_screen_hint_title, show_screen_sharing: true });
                    this.salvar_log_permission('Compartilhou a opção errada de tela: ' + displaySurface);

                }
                else {
                    let track = silence();
                    strm.addTrack(track);
                    this.stream_screen = strm;
                    this.stream_screen.getVideoTracks()[0].onended = () => {
                        console.log('inactive')
                        this.stream_screen = null;
                        if (this.unmont_ == false) {
                            this.setState({ loading_camera: false, msg: t.share_full_screen_to_continue, show_screen_sharing: true, show_screen: false, show_aceitar: false });
                        }
                        else {
                        }
                        this.props.changeState({ stream_screen: null })
                        console.log('teste')
                        this.salvar_log_permission('Cancelou permissão de compartilhamento de tela');

                    }
                    this.screenRef.current.style.display = 'flex';
                    this.screenRef.current.volume = 0;
                    this.screenRef.current.srcObject = strm;
                    this.setState({ show_aceitar: true, loading_camera: false, show_screen: true });
                    this.salvar_log_permission('Aceitou permissão de compartilhamento de tela');
                }
            })
            .catch((err) => {
                this.setState({ loading_camera: false, msg: t.share_full_screen_to_continue, show_screen_sharing: true });
                console.error(err)
                try {
                    this.salvar_log_permission('Recusou permissão de compartilhamento de tela: ' + err);
                }
                catch (e) {

                }
            });
    }



    handleError(stream) {
        console.log(stream);
        const t = getLanguageTexts(getSelectedLanguage());
        let msg = '';
        localStorage.removeItem("deviceId");
        localStorage.removeItem("deviceIdMic");


        if (stream.toString().includes('Permission denied')) {
            msg = t.camera_permission_denied;
        }
        else if (stream.toString().includes('Permission dismissed')) {
            msg = t.camera_permission_dismissed;
        }
        else if (stream.toString().includes('Could not start video source')) {
            msg = t.camera_start_error;
        }
        else if (stream.toString().includes('Could not start audio source')) {
            msg = t.microphone_start_error;
        }
        else if (stream.toString().includes('NotFoundError')) {
            msg = t.media_not_found;
        }
        else {
            msg = stream.toString();
        }
        this.setState({ show_solicitar: true, loading_camera: false, stream: null, msg: msg });
        this.salvar_log_permission(msg+' '+stream.toString());
    }

    change_device(event) {
        this.setState({show_screen:false,show_screen_sharing:false,show_aceitar:false});
        this.props.mudarDevices({ devices_camera: this.props.devices_camera, devices_mic: this.props.devices_mic,device_select_mic:this.props.device_select_mic, device_select: event.target.value })
        this.props.changeStateParent({audio_detected:false,left_movement:false,face_detected:false,right_movement:false,center_movement:false,})
        // console.log(event);
        localStorage.setItem("deviceId", event.target.value);

        navigator.mediaDevices.getUserMedia({
            video: {
                deviceId: {exact:event.target.value}, frameRate: 4,
                facingMode: "user",
                width: 320,
                height: 240
            }, audio: {deviceId:{exact:this.props.device_select_mic}}
        }).
            then(this.handleSuccess.bind(this)).catch(this.handleError.bind(this));
    }



    change_device_mic(event) {
        this.setState({show_screen:false,show_screen_sharing:false,show_aceitar:false});
        this.props.mudarDevices({ devices_camera: this.props.devices_camera, devices_mic: this.props.devices_mic, device_select_mic: event.target.value })
        this.props.changeStateParent({audio_detected:false,left_movement:false,face_detected:false,right_movement:false,center_movement:false,})
        // console.log(event);
        localStorage.setItem("deviceIdMic", event.target.value);

        navigator.mediaDevices.getUserMedia({
            video: {
                deviceId: {exact:this.props.device_select}, frameRate: 4,
                facingMode: "user",
                width: 320,
                height: 240
            }, audio: {deviceId:{exact:event.target.value}}
        }).
            then(this.handleSuccess.bind(this)).catch(this.handleError.bind(this));
    }

    calculateValue(){
        if(this.props.processo.type_fiscalization=='none'){
            return 100;
        }

        let total = 2;
        let completed = 0;

        if(this.props.stream_ref.current!=null){
            completed += 2;
        }

        if(this.props.processo.screen_sharing == true){
            total += 1;
            if(this.stream_screen!=null){
                completed += 1;
            }
        }

        if(this.props.processo.required_external_camera == true){
            total += 1;
            if(this.props.external_camera_connected == true){
                completed += 1;
            }
        }

        return Math.round((completed / total) * 100);
    }

    renderTips(){
            const t = getLanguageTexts(getSelectedLanguage());
            if(this.props.stream_ref.current == null){
                return <CandidateValidationNotice title={t.grant_camera_permissions}>{t.request_camera_microphone_permissions}</CandidateValidationNotice>;
            }
            else if(this.props.processo.screen_sharing==true && this.stream_screen ==null) {
                return <CandidateValidationNotice title={t.full_screen_hint_title}>{t.full_screen_hint}</CandidateValidationNotice>;
            }
            else {
                return <CandidateValidationNotice tone="success" title={t.terms_ready_title}>{t.terms_ready_hint}</CandidateValidationNotice>;
            }
    }

    

    render() {
        const t = getLanguageTexts(getSelectedLanguage());
        console.log(this.props.device_select_mic)
        return (
            <div className="row candidate-terms-page">
                {this.state.redirect == true && <Redirect to={this.state.path} />}

                <SelectProccess selectProccess={(processo_id) => this.props.selectProccess(processo_id)} processos={this.props.processos} show_proccess={this.props.show_proccess} setShowProccess={(e) => this.props.setShowProccess(e)} />


                <div className="col-12 candidate-exam-column">
                    <div className="card candidate-terms-card">
                        <div className="card-body candidate-terms-body">
                            <span className="candidate-section-kicker">{t.preparation_stage}</span>
                            <h4 className="mt-0 header-title candidate-process-title">{this.props.processo.name}</h4>
                            <p className="candidate-name">{t.candidate_name}: <strong>{this.props.user.name}</strong></p>

                            {this.props.faculdade.logo != null && <div className="candidate-terms-brand">
                                <img className="candidate-terms-logo" src={this.props.faculdade.logo} alt="Logo da instituição" />
                            </div>}

                            {/* <hr /> */}
                            {this.props.processo.recurso_period==true && 
                            <>
                            <Link to="/recursos" className="btn btn-warning btn-lg candidate-full-action">
                                <FileText size={22} weight="bold" />
                                {t.go_to_appeals_section}
                             </Link>
                                        {/* <hr /> */}
                            </>
                                        }
                            <div className="row">
                                <div className="col-12 candidate-permission-heading">
                                    <div><span className="candidate-section-kicker">{t.information}</span></div>
                                </div>

                                <div className="col-12 jodit-wysiwyg candidate-terms-content" dangerouslySetInnerHTML={{ __html: this.props.faculdade.termos }}>

                                </div>
                            </div>
                            {/* <hr /> */}
                            <div className="row">
                                <div className="col-12 d-flex justify-content-center align-items-center">
                                    {this.state.show_video == true && (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') &&
                                        <div>
                                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                <div id="video_show" className="candidate-media-preview" style={{ position: 'relative',maxWidth:400 }}>
                                                    <b><VideoCamera size={20} weight="bold" /> {t.camera}</b>
                                                    
                                                    {/* {this.props.loading_media==true && <div style={{position:'absolute',top:'40%',left:'50%', display:'flex',justifyContent:'center',alignItems:'center'}}>
                                                        <CircularProgress/>
                                                    </div>} */}
                                                    <video  autoPlay muted style={{transform: 'rotateY(180deg)', height: '250px', display: 'none', maxWidth: '100%', borderRadius: 15 }} id="video" ref={this.videoRef}>
                                                    </video>
                                                    
                                                    <div className='candidate-media-settings' style={{
                                                        fontSize: 24,
                                                        color: 'white',
                                                        position: 'absolute',
                                                        right: 10,
                                                        top: 8,
                                                        cursor: 'pointer'
                                                    }}>

                                                     <i onClick={() => {
                                                        this.setState({ show_config: !this.state.show_config })
                                                    }}  className='mdi mdi-settings'></i>

                                                    </div>

                                                    
                                                     {this.state.show_config == true && <div className="form-group" style={{ marginTop: '1rem' }}>
                                                        <p style={{marginTop:5,marginBottom:0}}><b>{t.camera}: </b></p>
                                                        <select value={this.props.device_select} className="form-control" id="cameras" onChange={this.change_device.bind(this)}>
                                                            {this.props.devices_camera.map((item, id) => (
                                                                <option key={id} value={item.deviceId}>{item.label}</option>

                                                            ))}
                                                        </select>
                                                        <p style={{marginTop:5,marginBottom:0}}><b>{t.microphone}: </b></p>

                                                        <select value={this.props.device_select_mic} className="form-control" id="mics" onChange={this.change_device_mic.bind(this)}>
                                                            {this.props.devices_mic.map((item, id) => (
                                                                <option key={id} value={item.deviceId}>{item.label}</option>

                                                            ))}
                                                        </select>
                                                        {/* <ChangeCamModal /> */}
                                                    </div>}
                                                </div>
                                                {<div hidden={!this.state.show_screen} id="screen_show " className="candidate-media-preview" style={{ marginLeft: 5 }}>
                                                    <b><MonitorArrowUp size={20} weight="bold" /> {t.screen_shared}</b>

                                                    <video autoPlay muted style={{ height: '250px', display: 'none', maxWidth: '100%', borderRadius: 15 }} id="screen" ref={this.screenRef}></video>
                                                </div>}

                                            </div>


                                        </div>
                                    }

                                </div>
                                {this.props.processo.type_fiscalization != 'none' && <div className="col-12 candidate-permission-panel">
                                    <div className="candidate-permission-heading">
                                        <div><span className="candidate-section-kicker">{t.device_verification}</span><h5>{t.complete_requirements}</h5></div>
                                        <strong>{this.calculateValue()}%</strong>
                                    </div>
                                    <div className="candidate-requirements">
                                        <p className={`candidate-requirement-item ${(this.props.stream_ref.current != null) ? 'is-complete' : 'is-pending'}`}><VideoCamera size={22} weight="bold" /><span>{t.video_sharing}</span></p>
                                        <p className={`candidate-requirement-item ${(this.props.stream_ref.current != null) ? 'is-complete' : 'is-pending'}`}><Microphone size={22} weight="bold" /><span>{t.audio_sharing}</span></p>
                                        {this.props.processo.screen_sharing == true && <p className={`candidate-requirement-item ${(this.stream_screen != null) ? 'is-complete' : 'is-pending'}`}><MonitorArrowUp size={22} weight="bold" /><span>{t.full_screen_sharing}</span></p>}
                                        {this.props.processo.required_external_camera == true && <p className={`candidate-requirement-item ${(this.props.external_camera_connected == true) ? 'is-complete' : 'is-pending'}`}><VideoCamera size={22} weight="bold" /><span>{this.props.external_camera_connected == true ? t.external_camera_status_connected : t.external_camera_status_pending}</span></p>}
                                    </div>
                                    {this.props.processo.required_external_camera == true && this.props.external_camera_connected != true && <div className="candidate-external-camera-card">
                                        <div className="candidate-external-camera-copy">
                                            <span className="candidate-section-kicker">{t.external_camera_terms_title}</span>
                                            <p>{t.external_camera_terms_hint}</p>
                                            <div className={`candidate-external-camera-status ${(this.props.external_camera_connected == true) ? 'is-connected' : 'is-pending'}`}>
                                                <i className={(this.props.external_camera_connected == true) ? 'mdi mdi-check-circle-outline' : 'mdi mdi-cellphone-link'}></i>
                                                <strong>{this.props.external_camera_connected == true ? t.external_camera_status_connected : t.external_camera_status_pending}</strong>
                                            </div>
                                        </div>
                                        <div className="candidate-external-camera-qr-wrap">
                                            {this.props.external_camera_link != null && this.props.external_camera_link != '' ? <>
                                                <div className="candidate-external-camera-qr">
                                                    <QRCodeCanvas
                                                        value={this.props.external_camera_link}
                                                        size={184}
                                                        level="H"
                                                        includeMargin={true}
                                                    />
                                                    {this.props.faculdade != null && this.props.faculdade.logo != null && this.props.faculdade.logo != "" && <span className="candidate-external-camera-qr-logo"><img src={this.props.faculdade.logo} alt="" /></span>}
                                                </div>
                                                <a className="candidate-secondary-link" target="_blank" rel="noreferrer" href={this.props.external_camera_link}>
                                                    <i className="mdi mdi-open-in-new"></i> {t.external_camera_open_link}
                                                </a>
                                            </> : <div className="candidate-external-camera-qr-loading">
                                                <span className="spinner-border text-primary" role="status"></span>
                                                <span>{t.external_camera_link_loading}</span>
                                            </div>}
                                        </div>
                                    </div>}
                                    {/* {this.props.processo.face_validation && <>
                                    <p style={{ marginBottom: 0, color: (this.props.stream_ref.current != null && this.props.face_detected==true) ? 'green' : 'red' }}><i className={(this.props.stream_ref.current != null && this.props.face_detected==true) ? 'fa fa-check' : 'mdi mdi-close'}></i> Rosto detectado</p>
                                    <p style={{ marginBottom: 0, color: (this.props.stream_ref.current != null && this.props.left_movement==true && this.props.right_movement==true && this.props.center_movement==true) ? 'green' : 'red' }}><i className={(this.props.stream_ref.current != null && this.props.left_movement==true && this.props.right_movement==true && this.props.center_movement==true) ? 'fa fa-check' : 'mdi mdi-close'}></i> Movimentações</p>
                                    </>} */}
                                    <ProgressBar striped variant="info" animated label={`${this.calculateValue()}% ${t.completed}`} className="candidate-permission-progress" now={this.calculateValue()} max={100}  />
                                    {(this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && this.renderTips()}
                                                                        {this.props.connect == false && this.props.socket != null && <CandidateValidationNotice tone="warning" title={t.unstable_connection}>{t.unstable_connection}</CandidateValidationNotice>}
                                
                                </div>}
                                

                                <div className="col-12">
                                    {this.state.msg!='' && <CandidateValidationNotice tone="danger">{this.state.msg}</CandidateValidationNotice>
}
                                </div>
                                <div className="col-12 d-flex justify-content-center align-items-center candidate-permission-actions" id="button_div">
                                    {this.state.show_solicitar == true && (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && <button type="button" onClick={() => this.solicitar_camera()} className="btn btn-warning btn-lg waves-effect waves-light"

                                        style={{ width: '100%',textTransform:'uppercase' }}><CameraPlus size={22} weight="bold" /> {t.request_camera_microphone_permissions}</button>}
                                    {this.state.show_screen_sharing == true && (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && <button type="button" onClick={() => this.screenSharing()} className="btn btn-warning btn-lg waves-effect waves-light"
                                        style={{ width: '100%',textTransform:'uppercase' }}><MonitorArrowUp size={22} weight="bold" /> {t.share_full_screen}</button>}


                                    {this.state.loading_camera == true && <CandidateLoader compact title={t.requesting_permissions} description={t.confirm_browser_access} />}


                                    {((this.state.show_aceitar == true 
                                    && this.calculateValue()==100
                                ) || this.props.processo.type_fiscalization == 'none') &&
                                        <button 
                                        disabled={this.calculateValue()<100} 
                                        onClick={this.aceitar_termos.bind(this)} type="button" id="aceitar" className="btn btn-success btn-lg waves-effect waves-light candidate-icon-button" style={{ width: '100%',textTransform:'uppercase' }}><ShieldCheck size={22} weight="bold" /> {t.accept_terms_permissions_full}</button>
                                    }

                                </div>
                                {this.props.processo.simulado == false && this.state.chat_show == true && this.props.processo_resultado?.status != 'F' && (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && this.props.processo.chat_type != 'none' && <Chat send_message={(message) => this.send_message(message)} />}
                            </div>


                        </div>
                    </div>
                </div>

            </div>


        );
    }


}

const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        faculdade: state.AppReducer.faculdade,
        processo: state.AppReducer.processo,
        user: state.AppReducer.user,
        devices_camera: state.AppReducer.devices_camera,
        devices_mic: state.AppReducer.devices_mic,
        device_select: state.AppReducer.device_select,
        device_select_mic: state.AppReducer.device_select_mic,

        stream: state.AppReducer.stream,
        stream_screen: state.AppReducer.stream_screen,

        videoRef: state.AppReducer.videoRef,
        socket: state.AppReducer.socket,
        connect: state.AppReducer.connect,
        processo_resultado: state.AppReducer.processo_resultado,
        external_camera_connected: state.AppReducer.external_camera_connected,
        external_camera_link: state.AppReducer.external_camera_link,
        candidate_inside_screen: state.AppReducer.candidate_inside_screen,

        sala: state.AppReducer.sala,
        mensagens: state.AppReducer.mensagens,

    }
);

export default connect(mapsStateToProps, { changeState, mudarFaculdade, mudarUser, mudarStream, mudarDevices, mudarCamModal, logout, mudarProcesso })(Termos);
